import React from 'react';  
import { Header } from "./common/Header";
import { AboutUs } from './components/AboutUs';
import TabPanel from './common/TabPanel';
import { Home } from './components/Home';
import { ContactUs } from './components/ContactUs/ContactUs';
import { Login } from './components/Login';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

export const App = () => {
    const [menuVal, setMenuVal] = React.useState(0);
    const sendDataToParent = (index: number) => { 
        // the callback function    
        setMenuVal(index);
    };

    return (
        <Router>
            <Header sendDataToParent={sendDataToParent}></Header>

            <Routes>
                <Route path="/" element={
                    <div style={{marginTop: "70px"}}>
                        <TabPanel value={menuVal} index={0}>
                            <Home />
                        </TabPanel>  
                        <TabPanel value={menuVal} index={1}>
                            <AboutUs />
                        </TabPanel> 
                        <TabPanel value={menuVal} index={2}>
                            <ContactUs />
                        </TabPanel> 
                        <TabPanel value={menuVal} index={4}>
                            <Login />
                        </TabPanel>
                    </div>
                } />
            </Routes>
        </Router>
    );
}
